import {
  EHeadingStyleVariant,
  ELoaderSize,
  ETextStyleVariant,
  EToastVariant,
  Heading,
  Loader,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useToast } from '@/hooks/useToast';
import { useCardsData } from '@/services/getCards';
import { IFullUserInfo } from '@/services/types/user/user';

import { AddPaymentMethod } from './AddPaymentMethod/AddPaymentMethod';
import { PaymentMethodsList } from './PaymentMethodsList/PaymentMethodsList';

interface IPaymentMethodsProps {
  user: IFullUserInfo;
}

export const PaymentMethods = ({ user }: IPaymentMethodsProps) => {
  const intl = useIntl();
  const { showToast } = useToast();

  const {
    data: userCards,
    isError: error,
    isLoading: isLoadingUserCards,
    mutate: refreshUserCards,
  } = useCardsData(user.id);

  if (error) {
    showToast(
      EToastVariant.Error,
      intl.formatMessage({
        defaultMessage: 'Error',
        id: 'KN7zKn',
      }),
      intl.formatMessage({
        defaultMessage: 'Failed to load user payment methods.',
        id: '6aA0+C',
      }),
    );
  }

  return (
    <div className="mb-10">
      <div className="flex flex-col mb-10 gap-4">
        <Heading variant={EHeadingStyleVariant.H5}>
          <FormattedMessage defaultMessage="Payment methods" id="9k5qQl" />
        </Heading>
        <Text variant={ETextStyleVariant.MediumRegular} className="text-secondary-base">
          <FormattedMessage
            defaultMessage="Securely add and oversee your payment methods through our trusted payment system."
            id="n4BtZl"
          />
        </Text>
      </div>
      <div>
        {isLoadingUserCards ? (
          <div aria-hidden className="flex justify-center">
            <Loader size={ELoaderSize.Large} />
          </div>
        ) : (
          userCards &&
          userCards.length > 0 && (
            <PaymentMethodsList userCards={userCards} refreshUserCards={refreshUserCards} />
          )
        )}
      </div>
      <div className="mt-3">
        <AddPaymentMethod user={user} refreshUserCards={refreshUserCards} />
      </div>
    </div>
  );
};
